module.exports = __webpack_public_path__ + "img/dishesconfirm0.ed1b59db.png";